import type { SVGProps } from 'react';

export type IconName =
  | 'atlas'
  | 'mission'
  | 'briefing'
  | 'roadmap'
  | 'scenario'
  | 'tasks'
  | 'decision'
  | 'modules'
  | 'research'
  | 'sources'
  | 'profile'
  | 'settings'
  | 'search'
  | 'bell'
  | 'chevron'
  | 'close'
  | 'external'
  | 'calendar'
  | 'clock'
  | 'check'
  | 'warning'
  | 'lock'
  | 'download'
  | 'plus'
  | 'filter'
  | 'more'
  | 'evidence'
  | 'arrow'
  | 'shield'
  | 'menu'
  | 'grid'
  | 'table'
  | 'timeline';

const paths: Record<IconName, React.ReactNode> = {
  atlas: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c3 3 4 6 4 9s-1 6-4 9c-3-3-4-6-4-9s1-6 4-9Z" />
    </>
  ),
  mission: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="3" />
      <path d="m15 9 5-5" />
    </>
  ),
  briefing: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M7 8h4v4H7zM14 8h3M14 12h3M7 16h10" />
    </>
  ),
  roadmap: (
    <>
      <path d="M5 19V7m0 0 3 3m-3-3L2 10M19 5v12m0 0 3-3m-3 3-3-3M5 14h14" />
    </>
  ),
  scenario: (
    <>
      <path d="M4 19V8m0 0 4 4M4 8 8 4m12 15V8m0 0-4 4m4-4-4-4M8 12h8" />
    </>
  ),
  tasks: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="m8 9 1.5 1.5L12 8m2 2h3m-9 6 1.5 1.5L12 15m2 2h3" />
    </>
  ),
  decision: (
    <>
      <path d="M12 3v18M12 7H7a3 3 0 0 0-3 3v1m8 5h5a3 3 0 0 0 3-3v-1" />
      <path d="m7 8-3 3-3-3m16 8 3-3 3 3" />
    </>
  ),
  modules: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </>
  ),
  research: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m16 16 5 5M8 11h6m-3-3v6" />
    </>
  ),
  sources: (
    <>
      <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5v-16Z" />
      <path d="M4 19a2 2 0 0 1 2-2h14M8 7h8m-8 4h6" />
    </>
  ),
  profile: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.5-2.4 1A7 7 0 0 0 15 6l-.4-3h-5L9 6a7 7 0 0 0-1.5 1L5 6 3 9.5 5.1 11a7 7 0 0 0 0 2L3 14.5 5 18l2.5-1A7 7 0 0 0 9 18l.5 3h5l.5-3a7 7 0 0 0 1.5-1l2.5 1 2-3.5-2.1-1.5a7 7 0 0 0 .1-1Z" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m16 16 5 5" />
    </>
  ),
  bell: (
    <>
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />
    </>
  ),
  chevron: <path d="m9 18 6-6-6-6" />,
  close: <path d="M18 6 6 18M6 6l12 12" />,
  external: (
    <>
      <path d="M14 4h6v6M20 4l-9 9" />
      <path d="M18 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M16 3v4M8 3v4M3 10h18" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  check: <path d="m5 12 4 4L19 6" />,
  warning: (
    <>
      <path d="M12 3 2 21h20L12 3Z" />
      <path d="M12 9v5m0 3v.1" />
    </>
  ),
  lock: (
    <>
      <rect x="4" y="10" width="16" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12m0 0 5-5m-5 5-5-5M4 21h16" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  filter: <path d="M3 5h18l-7 8v6l-4 2v-8L3 5Z" />,
  more: (
    <>
      <circle cx="5" cy="12" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
    </>
  ),
  evidence: (
    <>
      <path d="M5 3h10l4 4v14H5V3Z" />
      <path d="M14 3v5h5M8 12h8m-8 4h6" />
    </>
  ),
  arrow: <path d="M5 12h14m-5-5 5 5-5 5" />,
  shield: (
    <>
      <path d="M12 3 4 6v6c0 5 3 8 8 10 5-2 8-5 8-10V6l-8-3Z" />
      <path d="m9 12 2 2 4-5" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
    </>
  ),
  table: (
    <>
      <path d="M3 5h18v14H3zM3 10h18M9 5v14" />
    </>
  ),
  timeline: (
    <>
      <path d="M5 3v18M5 7h5m-5 5h10m-10 5h7" />
      <circle cx="5" cy="7" r="2" />
      <circle cx="5" cy="12" r="2" />
      <circle cx="5" cy="17" r="2" />
    </>
  ),
};

export function Icon({
  name,
  size = 18,
  ...props
}: SVGProps<SVGSVGElement> & { name: IconName; size?: number }): React.JSX.Element {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {paths[name]}
    </svg>
  );
}
